import * as rmd from 'material-ui';
import React from 'react';
import config from 'cfg';
import Promise from 'bluebird';
import _ from 'lodash';
import styled from 'styled-components';

const Picker = styled.div`
    margin-top: 30px;
`;

const Event = styled.div`
    background: rgba(0, 0, 0, 0.2);
    margin: 0 -7px 5px;
    padding: 12px;
`;

const Title = styled.div`
    font-weight: normal;
    margin: 0;
    color: rgb(0, 160, 181);
`;

const POSITIONS_ORDER = ['keeper', 'defender', 'midfielder', 'forward'];

class PlayersComparisonPicker extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            tournament: {},
            events: [],
            players: props.players || {},
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentWillMount() {
        this.handleEventChange(this.state.events);
    }

    componentWillReceiveProps(newProps) {
        if (Number(this.props.round || '') !== Number(newProps.round || '')) {
            this.handleEventChange(null);
            this.props.onChange('players', {});
            this.setState({
                players: {},
            }, () => {
                this.loadData();
            });
        }
    }

    loadData() {
        const { tournamentId, stageIds, round } = this.props;

        return fetch(`${config.apis.ss2}/tournaments/${tournamentId}?locale=da`)
            .then(res => res.json())
            .then(tournament => {
                const { id, currentRound, seasonId } = tournament;

                return Promise.props({
                    tournament,
                    events: fetch(
                        `${config.apis.ss2}/events-v2?ttId[]=${id}&seasonId=${seasonId}&round=${round || currentRound}`,
                    )
                        .then(res => res.json())
                        .then(({ events }) => {
                            this.handleEventChange(events);

                            return events;
                        }),
                });
            })
            .then(result => this.setState(result));
    }

    handleEventChange = events => {
        if (!events) {
            return null;
        }

        return events.map(event => {
            return Promise.props({
                [event.homeId]: fetch(`${config.apis.ss2}/teams/${event.homeId}/members`)
                    .then(response => response.json())
                    .then(res => res.players),
                [event.awayId]: fetch(`${config.apis.ss2}/teams/${event.awayId}/members`)
                    .then(response => response.json())
                    .then(res => res.players),
            }).then(result => this.setState(result));
        });
    };

    renderOption(pl) {
        var text = `${pl.number || ''}. ${pl.name}`;

        return <rmd.MenuItem key={pl.id} value={pl.id} primaryText={text} />;
    }

    sortPlayersByType(players) {
        return _.orderBy(players, [pl => POSITIONS_ORDER.indexOf(pl.position), 'number']);
    }

    render() {
        const { events } = this.state;

        return (
            <Picker>
                {events.map(ev => {
                    return (
                        <Event>
                            <Title>
                                {ev.homeName} - {ev.awayName}
                            </Title>
                            <rmd.SelectField
                                floatingLabelText={`${ev.homeShortName} player`}
                                value={this.state.players[`${ev.homeId}`] || ''}
                                //disabled={!this.state.homeId}
                                maxHeight={400}
                                onChange={(e, key, val) =>
                                    this.setState(
                                        {
                                            players: { ...this.state.players, [ev.homeId]: val },
                                        },
                                        () => {
                                            this.props.onChange('players', { ...this.state.players, [ev.homeId]: val });
                                        },
                                    )
                                }
                            >
                                {this.sortPlayersByType(this.state[ev.homeId]).map(this.renderOption)}
                            </rmd.SelectField>
                            <rmd.SelectField
                                floatingLabelText={`${ev.awayShortName} player`}
                                value={this.state.players[`${ev.awayId}`] || ''}
                                //disabled={!this.state.homeId}
                                maxHeight={400}
                                onChange={(e, key, val) =>
                                    this.setState(
                                        {
                                            players: { ...this.state.players, [ev.awayId]: val },
                                        },
                                        () => {
                                            this.props.onChange('players', { ...this.state.players, [ev.awayId]: val });
                                        },
                                    )
                                }
                            >
                                {this.sortPlayersByType(this.state[ev.awayId]).map(this.renderOption)}
                            </rmd.SelectField>
                        </Event>
                    );
                })}
            </Picker>
        );
    }
}

export default PlayersComparisonPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/PlayersComparisonPicker.js
 **/